var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundRaiseSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2856 10.2969C16.2846 10.2969 15.4727 11.1087 15.4727 12.1097C15.4727 13.1119 16.2847 13.9235 17.2856 13.9235H21.1723C21.5865 13.9235 21.9223 14.2593 21.9223 14.6735C21.9223 15.0877 21.5865 15.4235 21.1723 15.4235H17.2856C15.456 15.4235 13.9727 13.9399 13.9727 12.1097C13.9727 10.2803 15.4561 8.79688 17.2856 8.79688H21.1418C21.556 8.79688 21.8918 9.13265 21.8918 9.54688C21.8918 9.96108 21.556 10.2969 21.1418 10.2969H17.2856Z",
    fill: "#5B4200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6758 12.0469C16.6758 11.6327 17.0116 11.2969 17.4258 11.2969H17.7229C18.1371 11.2969 18.4729 11.6327 18.4729 12.0469C18.4729 12.4612 18.1371 12.7969 17.7229 12.7969H17.4258C17.0116 12.7969 16.6758 12.4612 16.6758 12.0469Z",
    fill: "#5B4200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85742 8.14062C6.85742 7.7264 7.1932 7.39062 7.60742 7.39062H11.6674C12.0816 7.39062 12.4174 7.7264 12.4174 8.14062C12.4174 8.55483 12.0816 8.89062 11.6674 8.89062H7.60742C7.1932 8.89062 6.85742 8.55483 6.85742 8.14062Z",
    fill: "#5B4200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25646 6.13115C4.04418 7.24413 3.46484 9.10161 3.46484 12.2499C3.46484 15.3978 4.04416 17.2553 5.25649 18.3684C6.48807 19.4992 8.55883 20.039 12.0158 20.039C15.4722 20.039 17.5427 19.4992 18.7742 18.3685C19.9864 17.2553 20.5658 15.3978 20.5658 12.2499C20.5658 9.10161 19.9864 7.24411 18.7742 6.13113C17.5428 5.00047 15.4723 4.46094 12.0158 4.46094C8.55877 4.46094 6.48803 5.00047 5.25646 6.13115ZM4.24203 5.0262C5.91689 3.48854 8.49663 2.96094 12.0158 2.96094C15.5345 2.96094 18.114 3.48855 19.7887 5.02622C21.4827 6.58157 22.0658 8.99359 22.0658 12.2499C22.0658 15.5059 21.4827 17.9179 19.7887 19.4733C18.114 21.0111 15.5345 21.539 12.0158 21.539C8.49657 21.539 5.91685 21.0111 4.242 19.4733C2.5479 17.9179 1.96484 15.5059 1.96484 12.2499C1.96484 8.99359 2.54789 6.58155 4.24203 5.0262Z",
    fill: "#5B4200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundRaiseSelect);
export default __webpack_public_path__ + "static/media/FundRaiseSelect.49a76e1dfb93f660bc54d6c6b8f3ed56.svg";
export { ForwardRef as ReactComponent };